import React from 'react';
import { Spin } from 'antd';

export const SpinLoading = ({ loading, children }) => {
  return (
    <div style={{ position: 'relative' }}>
      {loading && (
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(255, 255, 255, 1)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000 // 상위 요소보다 높게 설정
          }}
        >
          <Spin size="large" />
        </div>
      )}
      {children}
    </div>
  );
};

export const CUMIRLoading = ({ loading, children }) => {
  return (
    <div style={{ position: 'relative' }}>
      {loading && (
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(255, 255, 255, 1)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000
          }}
        >
          <div style={{ textAlign: 'center', position: 'relative' }}>
            <span
              style={{
                fontSize: '2rem',
                fontWeight: 'bold',
                fontFamily: "'Comic Sans MS', cursive, sans-serif",
                position: 'relative',
                background: 'linear-gradient(90deg, rgba(0, 123, 255, 0.1) 25%, rgba(0, 123, 255, 1) 50%, rgba(135, 206, 250, 0.1) 75%)',
                backgroundSize: '200% 100%',
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                color: 'transparent',
                animation: 'loadingEffect 2s infinite linear'
              }}
            >
              QMIR
            </span>
          </div>
        </div>
      )}
      {children}
    </div>
  );
};

/* 애니메이션 추가 */
const style = document.createElement('style');
style.innerHTML = `
@keyframes loadingEffect {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
`;
document.head.appendChild(style);
